export function processMenu(ctx, { fetch, variables }) {
  return fetch(variables)
    .then(data => {
      let pairViewUser = Object.entries(data.successful.view_user);
      let filtered = pairViewUser.filter(
        ([key, value]) => value !== null && key !== "__typename"
      );
      if (filtered.length !== 0) {
        chooseMenu(
          "view_quanspire",
          "view_user",
          "selectedShowView",
          "view_user",
          ctx,
          data
        );
      } else {
        chooseMenu(
          "view_quanspire",
          "view_user",
          "selectedShowView",
          "view_quanspire",
          ctx,
          data
        );
      }
    })
    .catch(function(error) {
      console.log(error);
    });
}

function chooseMenu(vquanspire, vuser, sView, vselected, ctx, data) {
  ctx[vquanspire] = data.successful[vquanspire];
  ctx[vuser] = data.successful[vselected];
  var keys;
  keys = Object.keys(ctx[vselected]);
  const __typename = keys.indexOf("__typename");
  keys.splice(__typename, 1);
  if (ctx[sView] === undefined) {
    ctx.view = ctx[vselected];
  } else if (keys.indexOf(ctx[sView]) < 0) {
    ctx.view = ctx[vselected];
  } else {
    for (const key of keys) {
      if (ctx[vselected][key] === null) {
        delete ctx[vselected][key];
      } else {
        ctx[vselected][key].show = ctx[sView] === key;
      }
    }
    delete ctx[vselected].__typename;
    ctx.view = ctx[vselected];
  }
}
